export const sanitizeReferenceName = (referenceName: string) => referenceName.replace(/\s/g, '-').replace(/[^\w-]/g, '');
